import { AdjustmentTypes, getAdjustmentValue } from '@app/evaluation-core'
import {
  AdmFactorButton,
  AdmFactorButtonWrapper,
  AdmFactorText,
  AdmFactorTextLabel,
} from './AdjustmentFactors.styles'
import { AdmGroupFactor, AdmGroupFactorItem } from '../types'

import { AdjustmentFactorButton } from '../styles'
import { EvaluationUserView, LockStatus } from '@app/evaluation-core/types'
import React, { useEffect, useRef, useState } from 'react'
import { useEvaluation } from '@common/hooks'
import useSetAdjustment from '@common/hooks/useSetAdjustment'
import useEvaluationLockedState from '@common/hooks/useEvaluationLockedState'
import { AdjustmentInput } from '@app/ui/input'

interface FactorButtonProps {
  button: AdmGroupFactorItem
  buttonIndex: number
  adjustments: any
  factor: AdmGroupFactor
  view: EvaluationUserView
  useLz?: boolean
  useShot?: boolean
  showTextOnly?: boolean
  hideText?: boolean
  shotIndex?: number
}

function valueToButtonText(value: number) {
  return (value > 0 ? '+' : '') + value
}

const FactorButton: React.FC<FactorButtonProps> = ({
  button,
  adjustments,
  buttonIndex,
  factor,
  view,
  shotIndex,
  showTextOnly = false,
  hideText,
}: FactorButtonProps) => {
  const { currentId } = useEvaluation()
  const holeLocked = useEvaluationLockedState()
  const [setAdjustment, setExcludedKeys] = useSetAdjustment()
  const buttonShouldNotRender =
    button.shouldRender &&
    typeof button.shouldRender === 'function' &&
    !button.shouldRender(adjustments, view)
  const canEdit = holeLocked === LockStatus.UNLOCKED

  const adjustmentValue = getAdjustmentValue(
    factor.format as AdjustmentTypes,
    { ...view, shot: shotIndex !== undefined ? shotIndex : view.shot },
    factor.itemKey as string,
    adjustments
  )

  const [inputValue, setInputValue] = useState<string>(
    adjustmentValue?.toString() ?? ''
  )
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const adjustmentValueStr = adjustmentValue?.toString() ?? ''
    if (adjustmentValueStr !== inputValue) {
      if (inputRef.current) {
        inputRef.current.value = adjustmentValueStr
      }
      setInputValue(adjustmentValueStr)
    }
  }, [adjustmentValue, holeLocked])

  if (buttonShouldNotRender) return null
  const parseButtonValue = (value: number | string | undefined) => {
    if (!value) return
    if (Number.isInteger(value)) {
      return value
    } else {
      if ((value as string).includes('%')) {
        return parseInt((value as string).replace('%', ''))
      }
      return value
    }
  }

  const buttonIsSelected = adjustmentValue === parseButtonValue(button.value)
  // ? button.selected
  // : adjustment[factor.itemKey as string].adjusted?.option === buttonIndex + 1;

  const getButtonText = () => {
    // const value =
    //   button.value ?? adjustment[factor.itemKey as string].adjusted?.value;
    // if (Number.isInteger(value)) {
    //   if (factor.itemKey) {
    //     return valueToButtonText(
    //       button.value ?? adjustment[factor.itemKey].adjusted?.value
    //     );
    //   }
    //   return valueToButtonText(button.value as number);
    // }
    if (typeof button.value === 'number') {
      return button.value > 0 ? `+${button.value}` : button.value
    }
    return button.value as string
  }

  const handleClick = () => {
    console.log('**************************')
    console.log('CLICKED', { adjustmentValue, buttonValue: button.value })
    console.log('**************************')
    if (button.excludedKeys) {
      const value = adjustmentValue === button.value ? 0 : button.value
      return setExcludedKeys(
        'shot',
        { ...view, shot: shotIndex !== undefined ? shotIndex : view.shot },
        factor.itemKey as string,
        currentId as string,
        value as number,
        button.excludedKeys
      )
    }
    if (!button.disabled && factor.itemKey) {
      if (adjustmentValue === button.value) {
        return setAdjustment(
          factor.format as AdjustmentTypes,
          { ...view, shot: shotIndex !== undefined ? shotIndex : view.shot },
          factor.itemKey as string,
          currentId as string,
          0
        )
      }

      console.log('**************************')
      console.log('itemKey', factor.itemKey)
      console.log('value', parseButtonValue(button.value))
      console.log('view', {
        ...view,
        shot: shotIndex !== undefined ? shotIndex : view.shot,
      })
      console.log('currentId', currentId)
      console.log('format', factor.format as AdjustmentTypes)
      console.log('adjustment', adjustmentValue)
      console.log('buttonValue', button.value)
      console.log('**************************')

      return setAdjustment(
        factor.format as AdjustmentTypes,
        { ...view, shot: shotIndex !== undefined ? shotIndex : view.shot },
        factor.itemKey as string,
        currentId as string,
        parseButtonValue(button.value) as number
      )
    }
  }
  return (
    <AdmFactorButtonWrapper key={buttonIndex}>
      {/* {factor.mode === "percentage" && factor.itemKey && (
        <AdjustmentFactorInput
          value={
            // adjustments[factor.itemKey].adjusted.value > 0
            //   ? AdjustmentSubheader[factor.itemKey].adjusted.value
            //   : ""
          }
          // defaultValue={adjustments[factor.itemKey].adjusted.value ?? ""}
          onChange={({ target: { value } }) =>
            factor.onInputChange &&
            factor.onInputChange(value, adjustments, view, shotIndex)
          }
          type="number"
          max={100}
          placeholder="%"
        />
      )} */}
      {factor.mode === 'default' ||
        (!factor.mode && factor.itemKey && button.value !== undefined && (
          <AdmFactorButton wide={button.wideButton}>
            <AdjustmentFactorButton
              isReadonly={factor.disabled}
              disabled={!canEdit}
              selected={buttonIsSelected}
              onClick={handleClick}
              hideButton={button.hideButton}
              wide={button.wideButton}
            >
              {button.renderButtonText
                ? button.renderButtonText()
                : getButtonText()}
            </AdjustmentFactorButton>
          </AdmFactorButton>
        ))}
      {factor.mode === 'carry' && (
        <AdmFactorButton wide={button.wideButton}>
          <AdjustmentFactorButton
            isReadonly={button.disabled}
            disabled={!canEdit}
            selected={buttonIsSelected}
            onClick={handleClick}
            wide={button.wideButton}
          >
            {adjustmentValue}
          </AdjustmentFactorButton>
        </AdmFactorButton>
      )}

      {factor.mode === 'numeric-input' && factor.itemKey && (
        <AdmFactorButton>
          <AdjustmentInput
            ref={inputRef}
            onFocus={(event) => event.target.select()}
            isReadonly={factor.disabled}
            disabled={!canEdit}
            type="number"
            defaultValue={inputValue}
            onChange={({ target }) => {
              if (holeLocked !== LockStatus.LOCKED) {
                setInputValue(target.value)
              }
            }}
            onBlur={({ target }) => {
              if (factor.itemKey && !button.disabled) {
                const numValue = target.value === '' ? 0 : +target.value
                setAdjustment(
                  factor.format as AdjustmentTypes,
                  {
                    ...view,
                    shot: shotIndex !== undefined ? shotIndex : view.shot,
                  },
                  factor.itemKey as string,
                  currentId as string,
                  numValue
                )
              }
              if (holeLocked === LockStatus.LOCKED && inputRef.current) {
                inputRef.current.value = adjustmentValue?.toString() ?? ''
              }
            }}
          />
        </AdmFactorButton>
      )}

      {!factor.factorText && !hideText && !buttonShouldNotRender && (
        <>
          {button.text && (
            <AdmFactorTextLabel style={{ padding: 15 }}>
              {button.text}
            </AdmFactorTextLabel>
          )}
          {button.renderText && button.renderText(adjustments, view)}
          {factor.selectWidget && factor.selectWidget()}
        </>
      )}
    </AdmFactorButtonWrapper>
  )
}

export default FactorButton
